import React from 'react';
import { Link } from 'react-router-dom';

interface SubstitutionNoticeProps {
  className?: string;
}

const SubstitutionNotice: React.FC<SubstitutionNoticeProps> = ({ className = '' }) => (
  <p className={`text-[11px] leading-relaxed text-warm-500 ${className}`}>
    <span className="font-medium text-warm-600">A note on stock:</span>{' '}
    if your exact brand is temporarily unavailable, we may ship an equivalent
    generic — same active ingredient, dosage, and form, from another WHO-GMP
    licensed manufacturer. When this happens we add{' '}
    <span className="font-medium text-warm-600">bonus units</span> or a
    complementary item so you net more, not less. We email before shipping if
    anything changes.{' '}
    <Link
      to="/policy/cancellation-and-refund-policy"
      className="text-gold-700 hover:text-gold-600 underline underline-offset-2"
    >
      Full substitution rules →
    </Link>
  </p>
);

export default SubstitutionNotice;
